import { useContext } from 'react'
import { AuthContext, type AuthContextType } from '../context/auth-provider'

const useAuth = (): AuthContextType => useContext(AuthContext)

export default useAuth
